module.exports = __webpack_public_path__ + "img/photo-17.16e6ca49.jpg";